<div class="landingbg bg-white">
  <div class="mb-0 videobg px-3 px-md-5 py-3">


    <a queryParamsHandling="merge" [routerLink]="carousellinks[imgindex]" aria-label="VeEX Inc. homepage product video"
      title="Optimize with VeEX Inc.">
      <div class="video-container">

        <video id="mainvideo" #mainvideo preload="auto" autoplay muted loop playsinline class="rounded-3" width="700"
          height="300" poster="assets/images/maincarouselimages/full_homepage_video8.webp">
          <!-- <source src="assets/images/maincarouselimages/full_homepage_video8-1100w.webm" type="video/webm" /> -->
          <source src="assets/images/maincarouselimages/full_homepage_video8.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <span class="visually-hidden">Watch homepage product video</span>
    </a>
    <div class="banner-wrapper px-3">
      <span class="fixedbanner0 bannerbackground rounded-3 text-center">
        <!-- <h1 class="p-0 m-0 d-inline fw-bold h4 text-white"><span class="mb-2 fs-5">Optimize Your 800G Network Testing</span><br><a
            queryParamsHandling="merge" routerLink="/products/rxt6811module"
            [queryParams]="{ product: 'RXT-6811' }"><button
              class="btn ctabtn rounded-3 btn-sm small mt-2 px-3 py-2 d-inline-flex align-items-center">Explore
              RXT-6811&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-caret-right-fill" viewBox="0 0 16 16">
                <path
                  d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg></button></a></h1> -->
        <!-- <h1 class="p-0 m-0 d-inline fw-bold h4 text-white"><span class="mb-2 fs-5">https://www.veexinc.com{{ carousellinks[imgindex] }}</span><br> -->
        <a queryParamsHandling="merge" [routerLink]="carousellinks[imgindex]">

          <button class="btn ctabtn rounded-3 btn-sm small px-3 py-2 d-inline-flex align-items-center">Find Out
            More&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-caret-right-fill" viewBox="0 0 16 16">
              <path
                d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
            </svg></button>
        </a>
        <!-- </h1> -->
      </span>
    </div>
  </div>
  <!-- <div class="d-flex justify-content-center videobg px-3 px-md-5">
    <div class="fixedbanner1 bannerbackground1 rounded-3 text-center p-4">
      <h1 class="p-0 m-0 d-inline h3 text-white"><span class="mb-3">Optimize Your 800G Network Testing</span><br><a
          queryParamsHandling="merge" routerLink="/products/rxt6811module"
          [queryParams]="{ product: 'RXT-6811' }"><button name="RXT-6811"
            class="btn ctabtn1 rounded-3 btn-sm small mt-2 px-3 py-2 shadow d-inline-flex align-items-center">Explore
            RXT-6811&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-caret-right-fill" viewBox="0 0 16 16">
              <path
                d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
            </svg></button></a></h1>
    </div>
  </div> -->
  <span class="my-3">
    <app-nested-nav-landing-v2></app-nested-nav-landing-v2>
  </span>
  <!-- <hr class="p-0 m-0"> -->
  <app-website-companytest></app-website-companytest>
  <div class="corestyle mt-0 pt-0" id="target" #target>





    <div class="row text-center p-5 bg-light">

      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card" (mouseover)="changeP1Text=true" (mouseout)="changeP1Text=false">
          <div class="card-body square rounded-4 fst-italic text-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/coremetroaccess_LR.webp)' }">
            <a class="stretched-link text-content rounded-4 text-center" queryParamsHandling="merge"
              routerLink="/productcategory/ethernet">
              {{ changeP1Text ? ('LANDING.ETHFIBBACK' | translate) : ('LANDING.ETHFIBTILE' | translate) }}
            </a>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card" (mouseover)="changeP2Text=true" (mouseout)="changeP2Text=false">
          <div class="card-body square rounded-4 fst-italic text-overlay" (mouseover)="changeP2Text = true"
            (mouseout)="changeP2Text = false"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/fiber_LR.webp)' }">
            <a class="stretched-link text-content rounded-4 text-center" queryParamsHandling="merge"
              routerLink="productcategory/fiberoptics">
              {{ changeP2Text ? ('LANDING.FIBOPBACK' | translate) : ('LANDING.FIBOPTILE' | translate) }}
            </a>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card" (mouseover)="changeP3Text=true" (mouseout)="changeP3Text=false">
          <div class="card-body square rounded-4 fst-italic text-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/glowwire_LR.webp)' }">
            <a class="stretched-link text-content rounded-4 text-center" queryParamsHandling="merge"
              routerLink="productcategory/catv">
              {{ changeP3Text ? ('LANDING.CATVBACK' | translate) : ('LANDING.CATVTILE' | translate) }}
            </a>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card" (mouseover)="changeP4Text=true" (mouseout)="changeP4Text=false">
          <div class="card-body square rounded-4 fst-italic text-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/ethernet_LR.webp)' }">
            <a class="stretched-link text-content rounded-4 text-center" queryParamsHandling="merge"
              routerLink="productcategory/transport">
              {{ changeP4Text ? ('LANDING.TRANSPORTBACK' | translate) : ('LANDING.TRANSPORTILE' | translate) }}
            </a>
          </div>
        </div>
      </div>

      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card">
          <div class="card-body square rounded-4 micrositeborder fst-italic text-top-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/docsis31_LR.webp)' }">
            <a class="stretched-link" queryParamsHandling="merge"
              routerLink="/solutions/docsis31"></a>
              <h2 class="top-text h4 fw-bold text-white w-100">{{ 'LANDING.DOCSISTILE' | translate }} and 4.0</h2>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card">
          <div class="card-body square rounded-4 micrositeborder fst-italic text-top-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/wifihouseheart_LR.webp)' }">
            <a class="stretched-link" queryParamsHandling="merge"
              routerLink="/solutions/wifi-testing"></a>
              <h2 class="top-text h4 fw-bold text-white w-100">{{ 'LANDING.WIFITILE' | translate }}</h2>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card">
          <div class="card-body rounded-4 micrositeborder fst-italic text-top-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/r-phy_LR.webp)' }">
            <a class="stretched-link" queryParamsHandling="merge"
              routerLink="/solutions/daa-and-r-phy-ready-test-solutions">
            </a>
              <h2 class="top-text h4 fw-bold text-white w-100">{{ 'LANDING.RPHYTILE1' | translate }}</h2>
              <h2 class="bottom-text h4 fw-bold text-white w-100">{{ 'LANDING.RPHYTILE2' | translate }}</h2>
          </div>
        </div>
      </div>

      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-3">
        <div class="card">
          <div class="card-body rounded-4 micrositeborder fst-italic text-top-overlay"
            [ngStyle]="{ 'background-image': 'url(assets/images/tileimages/800_400G_tile.webp)' }">
            <a class="stretched-link" queryParamsHandling="merge"
              routerLink="/solutions/800g-400g-testing-the-future-of-communications"
              aria-label="800G & 400G: Testing the Future of Communications">
            </a>
          </div>
        </div>
      </div>


      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/products">
                <i class="bi bi-search landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.PRODFINDTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/company/aboutus"><i
                  class="bi bi-buildings landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.ABOUTUSTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/newsandevents/events">
                <i class="bi bi-calendar4-week landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.EVENTSTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/company/howtobuy">
                <i class="bi bi-cart2 landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.HOWTOBUYTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalLightBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/support/productregistration">
                <i class="bi bi-r-square landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.PRODREGTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="borderpadding col-12 col-sm-12 col-md-6 col-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="generalLightBlue square rounded-4 fst-italic d-flex justify-content-center align-items-center">
              <a class="stretched-link" queryParamsHandling="merge" routerLink="/apps"
                [queryParams]="{ product: 'Apps' }">
                <i class="bi bi-cloud-arrow-down-fill landingbicon"></i>
                <h3 class="m-0 h5 fw-bold">{{ 'LANDING.APPSTILE' | translate }}</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- News and Events -->
    <div class="d-flex align-items-center h-100 press p-5 bg-secondary-subtle">
      <div class="bg-white rounded-3 px-3 px-md-5 py-5 darkblue">
        <h3 class="h3 fw-bolder mt-0 text-center">{{ 'LANDING.PRESSRELEASETITLE' | translate }}</h3>
        <h4 class="h5 mb-0 fw-bold mt-3" [innerHTML]="pr.description"></h4>
        <p class="small darkblue" [innerHTML]="pr.date"></p>
        <span class="p-0">VeEX Inc., <span [innerHTML]="pr.text1 | safe: 'html'"></span><br>
          <p class="d-inline" *ngIf="pr.text2" [innerHTML]="pr.text2 | safe: 'html'"></p><a
            class="darkblue text-decoration-underline" [href]="pr.link" target="_blank"
            aria-label="Read more about the latest Press Release"> ...{{ 'LANDING.READMORE' | translate }}</a>
        </span>
      </div>
    </div>
  </div>
</div>
